export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f170d9ff245242891624e49f75db3f3a41bfc7c09&name=fetchTypeahead!'